import { render, staticRenderFns } from "./togetherAiUpgradeNew.vue?vue&type=template&id=51542bc8&scoped=true"
import script from "./togetherAiUpgradeNew.vue?vue&type=script&lang=js"
export * from "./togetherAiUpgradeNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51542bc8",
  null
  
)

export default component.exports